// extracted by mini-css-extract-plugin
export default {"Content":"ReadOnlyDialog_Content__eJIyl","Buttons":"ReadOnlyDialog_Buttons__6gykD","Button":"ReadOnlyDialog_Button__N-TL1","Details":"ReadOnlyDialog_Details__zt3Jn"};